
import React from "react";
import { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { useGuestContext } from "contexts/GuestContext";
import axios from "axios";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "assets/scss/light-bootstrap-dashboard-pro-react.scss?v=2.0.0";
import "assets/css/demo.css";

import AuthLayout from "./layouts/Auth.js";
import AdminLayout from "./layouts/Admin.js";
import ChingMingGuestPage from "./views/BaolinPrivate/ChingMingGuestPage";

import GuestPage from "./views/BaolinPrivate/GuestPage";
import VegeFestGuestPage from "./views/BaolinPrivate/VegeFestGuestPage";

import LunarGuestPage from "./views/BaolinPrivate/LunarGuestPage.js";
import LunarEventRegisterPage from "./views/Pages/private/LunarEventRegisterPage.js";
import LunarEventTicket from "./components/Private/LunarEventTicket/LunarEventTicket";

import VegeFestEventRegisterPage from "./views/Pages/private/VegeFestEventRegisterPage";
import ChingMingRegisterPage from "./views/Pages/private/ChingMingRegisterPage";
import EventRegisterPage from "./views/Pages/private/EventRegisterPage";
import EventCheckinSearchPage from "./views/Pages/private/EventCheckinSearchPage.js";
import EventCheckinPage from "./views/Pages/private/EventCheckinPage.js";
import VegeFestCheckinPage from "./views/Pages/private/VegeFestCheckinPage.js";
import NewYearCheckinPage from "./views/Pages/private/NewYearCheckinPage.js";
import ChingMingCheckinPage from "./views/Pages/private/ChingMingCheckinPage.js";
import EventTicket from "./components/Private/EventTicket/EventTicket";
import VegeFestEventTicket from "./components/Private/VegeFestEventTicket/VegeFestEventTicket";
import ChingMingEventTicket from "./components/Private/ChingMingEventTicket/ChingMingEventTicket";
import BudhaBathEventTicket from "./components/Private/BudhaBathEventTicket/BudhaBathEventTicket";
import { GuestProvider } from "./contexts/GuestContext"; // Import the provider
import LoginPage from "./views/Pages/private/LoginPage";
import { ChartsProvider } from "contexts/ChartsContext.js";
import BaolinDashboard from "./views/BaolinPrivate/BaolinDashboard";
import BudhaBathGuestPage from "./views/BaolinPrivate/BudhaBathGuestPage.js";
// import VegeFestEventRegisterPage from "./views/Pages/private/VegeFestEventRegisterPage";
import BudhaBathEventRegisterPage from "views/Pages/private/BudhaBathEventRegisterPage.js";
import LiangHuangEventRegisterPage from "views/Pages/private/LiangHuangRegisterPage.js";

const root = ReactDOM.createRoot(document.getElementById("root"));
axios.defaults.withCredentials = true;

const AuthenticatedRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = useAuth();

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated === null ? (
          <div>Loading...</div>  // Optionally show a loading indicator while checking auth status
        ) : isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
        )
      }
    />
  );
};

function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const validateAuth = async () => {
      try {
        await axios.get(`${process.env.REACT_APP_SERVER_URL}/auth/validate`, { withCredentials: true });
        setIsAuthenticated(true);
      } catch (error) {
        setIsAuthenticated(false);
      }
    };

    validateAuth();
  }, []);

  return isAuthenticated;
}

root.render(
  <GuestProvider>
    <ChartsProvider>
      <BrowserRouter>
        <Switch>

          {/* <Route path="/auth" render={(props) => <AuthLayout {...props} />} /> */}
          {/* <Route path="/admin" render={(props) => <AdminLayout {...props} />} /> */}
          <AuthenticatedRoute path="/admin" component={AdminLayout} />
          <Route path="/login" render={(props) => <LoginPage {...props} />} />
          <Route path="/register" render={(props) => <LiangHuangEventRegisterPage {...props} />} />
          <Route path="/chingming/event-ticket" render={(props) => <ChingMingEventTicket {...props} />} />
          <Route path="/chingming/checkin" render={(props) => <ChingMingCheckinPage {...props} />} />
          <Route path="/chingming" render={(props) => <ChingMingGuestPage {...props} />} />
          <Route path="/chingmingregister" render={(props) => <ChingMingRegisterPage {...props} />} />
          <Route path="/vegeregister" render={(props) => <VegeFestEventRegisterPage {...props} />} />
          <Route path="/event-ticket" render={(props) => <EventTicket {...props} />} />
          <Route path="/vegefest/event-ticket" render={(props) => <VegeFestEventTicket {...props} />} />
          <Route path="/buddhabath/event-ticket" render={(props) => <BudhaBathEventTicket {...props} />} />
          <Route path="/checkinSearch" render={(props) => <EventCheckinSearchPage {...props} />} />
          <Route path="/newyear/checkinSearch" render={(props) => <EventCheckinSearchPage {...props} />} />
          <Route path="/event/checkin" render={(props) => <EventCheckinPage {...props} />} />
          <Route path="/vegefest/checkin" render={(props) => <VegeFestCheckinPage {...props} />} />
          <Route path="/buddhabath/checkin" render={(props) => <EventCheckinPage {...props} />} />
          {/* Lunar New Year Event pages */}
          <Route path="/newyear/event-ticket" render={(props) => <LunarEventTicket {...props} />} />
          <Route path="/newyear/checkin" render={(props) => <NewYearCheckinPage {...props} />} />
          <Route path="/newyear" render={(props) => <LunarGuestPage {...props} />} />
          <Route path="/newyearregister" render={(props) => <LunarEventRegisterPage {...props} />} />

          {/* <Route path="/guest" render={(props) => <GuestPage {...props} />} /> */}
          <Route path="/guest" render={(props) => <LunarGuestPage {...props} />} />
          <Route path="/vegefest" render={(props) => <VegeFestGuestPage {...props} />} />
          <Route path="/buddhabathing" render={(props) => <BudhaBathGuestPage {...props} />} />
          <Route path="/buddhabathregister" render={(props) => <BudhaBathEventRegisterPage {...props} />} />
          <Redirect from="/admin" to="/admin/dashboard" />
          <Redirect from="/" to="/guest" />

        </Switch>
      </BrowserRouter>
    </ChartsProvider>
  </GuestProvider>
);
